var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKdg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9896_14463)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9896_14463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.70508 7.79688H4.70526V9.68157L6.46748 7.79688H7.77383L5.75646 9.9061L7.94733 12.3351H6.54912L4.70526 10.1817V12.3351H3.70508V7.79688Z",
    fill: "url(#paint0_linear_9896_14463)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.29492 7.79688H9.79519C10.1592 7.79688 10.5028 7.8377 10.8294 7.91935C11.156 8.00099 11.4417 8.13027 11.6833 8.31397C11.9282 8.49428 12.1187 8.73242 12.2616 9.02158C12.4045 9.31075 12.4759 9.66456 12.4759 10.0796C12.4759 10.447 12.4079 10.7702 12.2684 11.0492C12.1289 11.3281 11.9418 11.5629 11.7071 11.7534C11.4724 11.9439 11.2002 12.0868 10.894 12.1854C10.5878 12.2841 10.2647 12.3317 9.92787 12.3317H8.29492V7.79688ZM9.2951 11.4098H9.8156C10.0469 11.4098 10.2613 11.386 10.4586 11.3383C10.6559 11.2907 10.8294 11.2125 10.9757 11.1036C11.122 10.9947 11.2342 10.8518 11.3193 10.6749C11.4009 10.498 11.4451 10.2803 11.4451 10.0252C11.4451 9.80404 11.4043 9.61012 11.3193 9.44683C11.2376 9.28354 11.122 9.14746 10.9825 9.03859C10.843 8.93313 10.6763 8.85149 10.4858 8.79705C10.2953 8.74262 10.0946 8.71541 9.88704 8.71541H9.2985V11.4098H9.2951Z",
    fill: "url(#paint1_linear_9896_14463)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.98 11.9099C16.7011 12.0561 16.4051 12.1616 16.1023 12.2262C15.7962 12.2909 15.4866 12.3249 15.1702 12.3249C14.8334 12.3249 14.5204 12.2705 14.2381 12.1684C13.9523 12.0629 13.7073 11.9133 13.4998 11.7159C13.2923 11.5186 13.129 11.2805 13.0133 11.0015C12.8977 10.7226 12.8398 10.4096 12.8398 10.066C12.8398 9.72239 12.8977 9.40941 13.0133 9.13045C13.129 8.85149 13.2923 8.61335 13.4998 8.41603C13.7073 8.21872 13.9523 8.06903 14.2381 7.96357C14.517 7.85131 14.83 7.79688 15.1668 7.79688C15.5104 7.79688 15.8302 7.8377 16.1227 7.92275C16.4119 8.0044 16.6705 8.14728 16.8882 8.3514L16.218 9.08282C16.0887 8.95014 15.9424 8.84808 15.7791 8.78004C15.6158 8.712 15.4117 8.67798 15.1702 8.67798C14.9661 8.67798 14.7824 8.712 14.6191 8.78004C14.4558 8.84808 14.3129 8.94674 14.1938 9.06921C14.0748 9.19168 13.9863 9.34137 13.9217 9.51147C13.857 9.68157 13.8264 9.86527 13.8264 10.066C13.8264 10.2701 13.857 10.4538 13.9217 10.6239C13.9863 10.7906 14.0748 10.9369 14.1938 11.0628C14.3129 11.1852 14.4524 11.2839 14.6191 11.3519C14.7824 11.42 14.9695 11.454 15.1702 11.454C15.3777 11.454 15.558 11.4302 15.7077 11.3826C15.8574 11.3349 15.9799 11.2873 16.0683 11.2397V10.5355H15.2927V9.65775H16.9834V11.9099H16.98Z",
    fill: "url(#paint2_linear_9896_14463)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9896_14463",
    x1: 5.82626,
    y1: 9.31416,
    x2: 5.82626,
    y2: 12.3341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F88F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26E55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9896_14463",
    x1: 10.3863,
    y1: 9.31416,
    x2: 10.3863,
    y2: 12.3341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F88F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26E55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9896_14463",
    x1: 14.9071,
    y1: 9.3104,
    x2: 14.9071,
    y2: 12.3235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F88F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26E55"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9896_14463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4653,
    height: 4.94532,
    fill: "white",
    transform: "translate(3.14258 7.57031)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9896_14463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.2745,
    height: 4.53823,
    fill: "white",
    transform: "translate(3.70508 7.79688)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKdg);
export default __webpack_public_path__ + "static/media/kdg.3718a1bec10a006dd5f9dc8b50298848.svg";
export { ForwardRef as ReactComponent };